<template>
    <section class="food-restriction-view">
        <HeaderComponent :title="'Restrição Alimentar'" />

        <div class="extract-container">
            <div class="actions">
                <div class="add" @click="loadAddMenuFields">
                    <i class="fa fa-square-plus fa-2xl fa-regular icon"></i>
                </div>

                <div class="export" @click="generatePDFExport">
                    <i class="fa fa-download icon"></i>
                </div>
            </div>

            <div class="search">
                <input type="text" placeholder="Buscar" v-model="searchText" @input="filterItems" />
                <i class="fa fa-search icon"></i>
            </div>

            <div id="foodRestrictionData" v-if="Object.values(filteredList).length > 0">
                <div class="list" v-for="(store, key) in filteredList" :key="key">
                    <h2 class="title" v-text="key"></h2>
                    <div class="list-fields">
                        <div v-for="(field, key) in fields" :key="key" class="list-field">
                            <h1 v-text="field"></h1>
                        </div>
                    </div>
                    <div v-if="loading" class="loading">
                        <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                    </div>
                    <div v-else v-for="(item, rkey) in store" :key="rkey" class="list-item" @click="editFoodLimit(item)">
                        <div class="list-item-field">
                            <span v-text="item.DSRESTRICAO"></span>
                        </div>
                        <div class="list-item-field">
                            <span class="limit" v-text="item.QTCONSDIARAL > 0 ? item.QTCONSDIARAL : 'Não pode consumir'"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="no-results">
                <div v-if="loading">
                    <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                </div>
                <h1 v-else>Não foram encontrados resultados</h1>
            </div>

        </div>

        <AddFoodLimitComponent @addRestriction="addRestriction" />

        <EditFoodLimitComponent
            :productName="selectedProduct.DSRESTRICAO"
            :productLimit="selectedProduct.QTCONSDIARAL"
            :productCantConsume="selectedProduct.QTCONSDIARAL == 0"
            :productWeekDays="selectedProduct.IDBLOQDIARAL"
            @closeMenu="updateLimit"
            @deleteProduct="deleteProduct"
        />
    </section>
</template>

<script>
import { showSuccessNotification, showAlertNotification, pdfExport } from '@/libs/Util.js'
import { loadFoodRestriction, updateFoodRestriction, getConsumerFamilies, addFoodRestriction, deleteFoodRestriction } from '@/components/controllers/FoodRestrictionController'
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import AddFoodLimitComponent from '@/components/bottom-popups/AddFoodLimitComponent.vue'
import EditFoodLimitComponent from '@/components/bottom-popups/EditFoodLimitComponent.vue'
import { mapActions, mapGetters } from 'vuex'
import { log } from '@/libs/Logger'

export default {
    name: 'FoodRestrictionView',
    components: {
        HeaderComponent,
        EditFoodLimitComponent,
        AddFoodLimitComponent
    },
    data () {
        return {
            fields: ['Produto', 'Limite Diário'],
            searchText: '',
            filteredList: [],
            selectedProduct: {},
            loading: false
        }
    },
    computed: {
        ...mapGetters(['getFoodRestrictions'])
    },
    methods: {
        ...mapActions(['changeEditRestrictionMenuVisibility', 'changeAddRestrictionMenuVisibility', 'showModalInfo', 'closeModalInfo']),
        filterItems: function () {
            this.filteredList = {}
            for (const key in this.getFoodRestrictions) {
                if (Object.hasOwnProperty.call(this.getFoodRestrictions, key)) {
                    const storeItems = this.getFoodRestrictions[key]

                    const filteredStoreItems = storeItems.filter(item => {
                        return item.DSRESTRICAO.toLowerCase().includes(this.searchText.toLowerCase())
                    })

                    if (filteredStoreItems.length > 0) {
                        this.filteredList[key] = filteredStoreItems
                    }
                }
            }
        },
        loadAddMenuFields: function () {
            getConsumerFamilies()
            this.changeAddRestrictionMenuVisibility()
        },
        generatePDFExport: function () {
            if (Object.values(this.getFoodRestrictions).length === 0) {
                showAlertNotification({
                    title: '',
                    text: 'Não há dados para exportar'
                })
                return
            }
            const fileName = 'Restrição de Produtos'
            const css = [
                {
                    elClass: 'title',
                    value: 'display: block;position: relative;color: orange;border-bottom: solid 2px orange;margin: 0;padding: 15px; font-size: 18px'
                },
                {
                    elClass: 'h1',
                    value: 'font-size: 25px'
                },
                {
                    elClass: 'list-field',
                    value: 'display: inline-block; width: 50%; text-align: center; font-weight: bold; font-size: 18px; margin-top: 20px;'
                },
                {
                    elClass: 'list-item',
                    value: 'margin: 10px 0'
                },
                {
                    elClass: 'list-item-field',
                    value: 'display: inline-block; width: 50%; text-align: center; font-size: 18px'
                }
            ]
            pdfExport({ id: 'foodRestrictionData', fileName, css })
        },
        editFoodLimit: function (item) {
            this.selectedProduct = item
            this.changeEditRestrictionMenuVisibility()
        },
        updateLimit: function (limit, weekDays) {
            updateFoodRestriction(
                limit,
                this.selectedProduct.IDPAI,
                this.selectedProduct.CDPRODUTO,
                weekDays
            ).then((res) => {
                this.loading = true
                if (res.rowsAffected) {
                    showSuccessNotification({
                        title: '',
                        text: 'Restrição atualizada com sucesso!'
                    })
                }
                loadFoodRestriction().then(() => {
                    this.loading = false
                })
            })
        },
        deleteProduct: function () {
            deleteFoodRestriction(this.selectedProduct.IDPAI, this.selectedProduct.CDPRODUTO).then(response => {
                this.loading = true
                if (response.rowsAffected) {
                    showSuccessNotification({
                        title: '',
                        text: 'Restrição removida com sucesso!'
                    })
                }
                loadFoodRestriction().then(() => {
                    this.loading = false
                    this.filterItems()
                })
            })
            this.changeEditRestrictionMenuVisibility()
        },
        addRestriction: function (restrictions) {
            this.loading = true
            addFoodRestriction(
                restrictions.productCodes,
                restrictions.CDFAMILISALD,
                restrictions.QTCONSDIARAL,
                restrictions.cdWeekDays
            ).then(response => {
                if (response.rowsAffected) {
                    showSuccessNotification({
                        title: '',
                        text: 'Restrições adicionadas com sucesso!'
                    })
                }
                loadFoodRestriction().then(() => {
                    this.loading = false
                    this.filterItems()
                })
            }).catch(error => {
                log({ type: 'error', message: error?.message })
                this.loading = false
            })
        }
    },
    mounted () {
    },
    created () {
        this.loading = true
        loadFoodRestriction()
        this.filteredList = {}
    },
    watch: {
        getFoodRestrictions: function () {
            this.loading = false
            this.filteredList = this.getFoodRestrictions
        }
    }
}
</script>

<style lang="less" scoped>
.extract-container{
    height: 100%;
    .actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        i {
          color: var(--iconColor)
        }
    }

    .export {
        display: flex;
        align-items: center;
        border: 1px solid var(--cardBorder);
        box-shadow: 2px 2px 4px var(--cardBorder);
        border-radius: 50px;
        box-sizing: border-box;
        padding: 5px 10px;
        border-radius: 5px;

        i {
            padding-bottom: 4px;
        }
    }

    .search {
        display: flex;
        align-items: center;
        margin-top: 30px;
        // grey background
        background-color: #d9d9d963;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px 10px;
        position: relative;

        input {
            border: none;
            outline: none;
            background-color: transparent;
            font-size: 18px;
            font-family: Gellix;
            width: 100%;
        }

        i {
            position: absolute;
            right: 10px;
            color: gray;
        }
    }

    .list-fields {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding: 0 4px;
        h1 {
            margin-bottom: 10px;
            font-weight: 600;
        }
    }

    .list {
        // altura até o fim da tela
        height: calc(100vh - 200px);
        overflow-y: scroll;
        padding: 0 4px;
        margin-top: 20px;

        &::-webkit-scrollbar {
        display: none;
        }

        h2 {
            margin-top: 20px;
            font-size: 16px;
            color: var(--iconColor);
            font-weight: bold;
        }

        // center icon
        .loading {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .list-item {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding-bottom: 20px;
        padding: 20px 10px;
        border: 1px solid var(--cardBorder);
        box-shadow: 2px 2px 4px var(--cardBorder);
        border-radius: 5px;

        .list-item-field {
            max-width: 50%;
            h1 {
                font-size: 16px;
            }
            .limit {
                font-weight: 600;
                text-align: right;
            }
        }

        &:last-of-type {
            margin-bottom: 30px;
        }
    }

    .no-results {
        display: flex;
        justify-content: center;
        font-size: 20px;
        margin-top: 20px;

        h1 {
            font-weight: 500;
        }
    }
}

</style>
